import {SCHEDULE_SESSION_DISPLAY_TYPE_BREAK} from '../constants';

export function isSessionBreak(session) {
    return session.display_type == SCHEDULE_SESSION_DISPLAY_TYPE_BREAK;
}
